module.exports = __webpack_public_path__ + "media/site_templates/www.plasterer.company/images/our_services_2-be2e0ed342984b4ebd511360530f08b8.jpg";